import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { rebassProps } from '../../../../theme/theme';
import ResetFiltersButton from '../../../../components/FilterBar/ResetFiltersButton';
import { getStringSearchPlaceholder } from '../../../../helpers/search';
import { searchFields } from './HazardSites';
import TagPicker from '../../../../components/TagPicker/TagPicker';

export type HazardSiteFilters = {
  stringSearch?: string | undefined;
  tags?: string[];
};

export const defaultFilters: HazardSiteFilters = {
  stringSearch: undefined,
  tags: undefined,
};

type FilterBarHazardSitesProps = FilterBarProps<HazardSiteFilters>;

const FilterBarHazardSites: React.FC<FilterBarHazardSitesProps> = (props) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(searchFields)}
          autoFocus={isBrowser && !selectedId}
          width={300}
          name="stringSearch"
          value={filters.stringSearch === undefined ? '' : filters.stringSearch}
          onChange={onChange}
        />
        <TagPicker
          value={filters.tags}
          placeholder="Filter by tags..."
          onChange={(newTags) =>
            setFilters((prev) => ({
              ...prev,
              tags: newTags.length > 0 ? newTags.slice() : undefined,
            }))
          }
        />
      </Flex>
      <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex>
    </Flex>
  );
};

FilterBarHazardSites.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarHazardSites;
